export const SerifFont = {
    smufl: false,
    name: 'SERIF',
    spacing: 50,
    Description: 'Built-in serif font',
    bold: true,
    italic: true,
    monospaced: false,
    serifs: true,
    glyphs: {
        '0': {
            xMin: 49,
            xMax: 975,
            yMin: -27,
            yMax: 1383,
            ha: 1410,
            leftSideBearing: 49,
            advanceWidth: 1024,
        },
        '1': {
            xMin: 227,
            xMax: 811,
            yMin: 0,
            yMax: 1383,
            ha: 1383,
            leftSideBearing: 227,
            advanceWidth: 1024,
        },
        '2': {
            xMin: 61,
            xMax: 965,
            yMin: 0,
            yMax: 1383,
            ha: 1383,
            leftSideBearing: 61,
            advanceWidth: 1024,
        },
        '3': {
            xMin: 88,
            xMax: 883,
            yMin: -27,
            yMax: 1383,
            ha: 1410,
            leftSideBearing: 88,
            advanceWidth: 1024,
        },
        '4': {
            xMin: 25,
            xMax: 967,
            yMin: 0,
            yMax: 1384,
            ha: 1384,
            leftSideBearing: 25,
            advanceWidth: 1024,
        },
        '5': {
            xMin: 66,
            xMax: 898,
            yMin: -27,
            yMax: 1409,
            ha: 1436,
            leftSideBearing: 66,
            advanceWidth: 1024,
        },
        '6': {
            xMin: 70,
            xMax: 958,
            yMin: -27,
            yMax: 1401,
            ha: 1428,
            leftSideBearing: 70,
            advanceWidth: 1024,
        },
        '7': {
            xMin: 41,
            xMax: 920,
            yMin: -16,
            yMax: 1356,
            ha: 1372,
            leftSideBearing: 41,
            advanceWidth: 1024,
        },
        '8': {
            xMin: 115,
            xMax: 911,
            yMin: -27,
            yMax: 1383,
            ha: 1410,
            leftSideBearing: 115,
            advanceWidth: 1024,
        },
        '9': {
            xMin: 61,
            xMax: 940,
            yMin: -41,
            yMax: 1383,
            ha: 1424,
            leftSideBearing: 61,
            advanceWidth: 1024,
        },
        ' ': {
            xMin: 0,
            xMax: 0,
            yMin: 0,
            yMax: 0,
            ha: 0,
            leftSideBearing: 0,
            advanceWidth: 512,
        },
        '!': {
            xMin: 266,
            xMax: 488,
            yMin: -22,
            yMax: 1383,
            ha: 1405,
            leftSideBearing: 266,
            advanceWidth: 682,
        },
        '"': {
            xMin: 157.2000021972655,
            xMax: 678.2500021457677,
            yMin: 881,
            yMax: 1385,
            ha: 504,
            leftSideBearing: 157,
            advanceWidth: 836,
        },
        '#': {
            xMin: 10,
            xMax: 1016,
            yMin: -1,
            yMax: 1356,
            ha: 1357,
            leftSideBearing: 10,
            advanceWidth: 1024,
        },
        $: {
            xMin: 90,
            xMax: 936,
            yMin: -180,
            yMax: 1492,
            ha: 1672,
            leftSideBearing: 90,
            advanceWidth: 1024,
        },
        '%': {
            xMin: 125,
            xMax: 1581,
            yMin: -30,
            yMax: 1388,
            ha: 1418,
            leftSideBearing: 125,
            advanceWidth: 1706,
        },
        '&': {
            xMin: 86,
            xMax: 1536,
            yMin: -28,
            yMax: 1383,
            ha: 1411,
            leftSideBearing: 86,
            advanceWidth: 1593,
        },
        "'": {
            xMin: 97.20000219726548,
            xMax: 273.2500021457677,
            yMin: 881,
            yMax: 1385,
            ha: 504,
            leftSideBearing: 97,
            advanceWidth: 369,
        },
        '(': {
            xMin: 98,
            xMax: 623,
            yMin: -363,
            yMax: 1383,
            ha: 1746,
            leftSideBearing: 98,
            advanceWidth: 682,
        },
        ')': {
            xMin: 59,
            xMax: 584,
            yMin: -363,
            yMax: 1383,
            ha: 1746,
            leftSideBearing: 59,
            advanceWidth: 682,
        },
        '*': {
            xMin: 137.96078522291893,
            xMax: 886.039214777081,
            yMin: 543,
            yMax: 1383,
            ha: 840,
            leftSideBearing: 137,
            advanceWidth: 1024,
        },
        '+': {
            xMin: 61,
            xMax: 1093,
            yMin: 2,
            yMax: 1034,
            ha: 1032,
            leftSideBearing: 61,
            advanceWidth: 1155,
        },
        ',': {
            xMin: 115,
            xMax: 399,
            yMin: -291,
            yMax: 208,
            ha: 499,
            leftSideBearing: 115,
            advanceWidth: 512,
        },
        '-': {
            xMin: 80,
            xMax: 584,
            yMin: 396,
            yMax: 525,
            ha: 129,
            leftSideBearing: 80,
            advanceWidth: 682,
        },
        '.': {
            xMin: 143,
            xMax: 371,
            yMin: -22,
            yMax: 205,
            ha: 227,
            leftSideBearing: 143,
            advanceWidth: 512,
        },
        '/': {
            xMin: -17,
            xMax: 586,
            yMin: -27,
            yMax: 1383,
            ha: 1410,
            leftSideBearing: -17,
            advanceWidth: 569,
        },
        ':': {
            xMin: 166,
            xMax: 394,
            yMin: -22,
            yMax: 943,
            ha: 965,
            leftSideBearing: 166,
            advanceWidth: 569,
        },
        ';': {
            xMin: 164,
            xMax: 448,
            yMin: -290,
            yMax: 943,
            ha: 1233,
            leftSideBearing: 164,
            advanceWidth: 569,
        },
        '<': {
            xMin: 57,
            xMax: 1098,
            yMin: -15,
            yMax: 1051,
            ha: 1066,
            leftSideBearing: 57,
            advanceWidth: 1155,
        },
        '=': {
            xMin: 61,
            xMax: 1093,
            yMin: 246,
            yMax: 791,
            ha: 545,
            leftSideBearing: 61,
            advanceWidth: 1155,
        },
        '>': {
            xMin: 57,
            xMax: 1098,
            yMin: -15,
            yMax: 1051,
            ha: 1066,
            leftSideBearing: 57,
            advanceWidth: 1155,
        },
        '?': {
            xMin: 139,
            xMax: 848,
            yMin: -15,
            yMax: 1383,
            ha: 1398,
            leftSideBearing: 139,
            advanceWidth: 909,
        },
        '@': {
            xMin: 238,
            xMax: 1657,
            yMin: -29,
            yMax: 1386,
            ha: 1415,
            leftSideBearing: 238,
            advanceWidth: 1886,
        },
        A: {
            xMin: 31,
            xMax: 1445,
            yMin: 0,
            yMax: 1380,
            ha: 1380,
            leftSideBearing: 31,
            advanceWidth: 1479,
        },
        B: {
            xMin: 35,
            xMax: 1214,
            yMin: 0,
            yMax: 1356,
            ha: 1356,
            leftSideBearing: 35,
            advanceWidth: 1366,
        },
        C: {
            xMin: 57,
            xMax: 1296,
            yMin: -28,
            yMax: 1383,
            ha: 1411,
            leftSideBearing: 57,
            advanceWidth: 1366,
        },
        D: {
            xMin: 33,
            xMax: 1403,
            yMin: 0,
            yMax: 1356,
            ha: 1356,
            leftSideBearing: 33,
            advanceWidth: 1479,
        },
        E: {
            xMin: 25,
            xMax: 1222,
            yMin: 0,
            yMax: 1356,
            ha: 1356,
            leftSideBearing: 25,
            advanceWidth: 1251,
        },
        F: {
            xMin: 25,
            xMax: 1119,
            yMin: 0,
            yMax: 1356,
            ha: 1356,
            leftSideBearing: 25,
            advanceWidth: 1139,
        },
        G: {
            xMin: 66,
            xMax: 1452,
            yMin: -28,
            yMax: 1383,
            ha: 1411,
            leftSideBearing: 66,
            advanceWidth: 1479,
        },
        H: {
            xMin: 39,
            xMax: 1438,
            yMin: 0,
            yMax: 1356,
            ha: 1356,
            leftSideBearing: 39,
            advanceWidth: 1479,
        },
        I: {
            xMin: 37,
            xMax: 642,
            yMin: 0,
            yMax: 1356,
            ha: 1356,
            leftSideBearing: 37,
            advanceWidth: 682,
        },
        J: {
            xMin: 20,
            xMax: 758,
            yMin: -28,
            yMax: 1356,
            ha: 1384,
            leftSideBearing: 20,
            advanceWidth: 797,
        },
        K: {
            xMin: 70,
            xMax: 1479,
            yMin: 0,
            yMax: 1356,
            ha: 1356,
            leftSideBearing: 70,
            advanceWidth: 1479,
        },
        L: {
            xMin: 25,
            xMax: 1224,
            yMin: 0,
            yMax: 1356,
            ha: 1356,
            leftSideBearing: 25,
            advanceWidth: 1251,
        },
        M: {
            xMin: 25,
            xMax: 1768,
            yMin: 0,
            yMax: 1356,
            ha: 1356,
            leftSideBearing: 25,
            advanceWidth: 1821,
        },
        N: {
            xMin: 25,
            xMax: 1450,
            yMin: -22,
            yMax: 1356,
            ha: 1378,
            leftSideBearing: 25,
            advanceWidth: 1479,
        },
        O: {
            xMin: 70,
            xMax: 1409,
            yMin: -28,
            yMax: 1383,
            ha: 1411,
            leftSideBearing: 70,
            advanceWidth: 1479,
        },
        P: {
            xMin: 33,
            xMax: 1110,
            yMin: 0,
            yMax: 1356,
            ha: 1356,
            leftSideBearing: 33,
            advanceWidth: 1139,
        },
        Q: {
            xMin: 70,
            xMax: 1435,
            yMin: -364.28571588721996,
            yMax: 1383,
            ha: 1747.28571588722,
            leftSideBearing: 70,
            advanceWidth: 1479,
        },
        R: {
            xMin: 35,
            xMax: 1347,
            yMin: 0,
            yMax: 1356,
            ha: 1356,
            leftSideBearing: 35,
            advanceWidth: 1366,
        },
        S: {
            xMin: 86,
            xMax: 1006,
            yMin: -28,
            yMax: 1383,
            ha: 1411,
            leftSideBearing: 86,
            advanceWidth: 1139,
        },
        T: {
            xMin: 35,
            xMax: 1214,
            yMin: 0,
            yMax: 1356,
            ha: 1356,
            leftSideBearing: 35,
            advanceWidth: 1251,
        },
        U: {
            xMin: 29,
            xMax: 1444,
            yMin: -28,
            yMax: 1356,
            ha: 1384,
            leftSideBearing: 29,
            advanceWidth: 1479,
        },
        V: {
            xMin: 33,
            xMax: 1428,
            yMin: -22,
            yMax: 1356,
            ha: 1378,
            leftSideBearing: 33,
            advanceWidth: 1479,
        },
        W: {
            xMin: 10,
            xMax: 1906,
            yMin: -22,
            yMax: 1356,
            ha: 1378,
            leftSideBearing: 10,
            advanceWidth: 1933,
        },
        X: {
            xMin: 20,
            xMax: 1449,
            yMin: 0,
            yMax: 1356,
            ha: 1356,
            leftSideBearing: 20,
            advanceWidth: 1479,
        },
        Y: {
            xMin: 45,
            xMax: 1441,
            yMin: 0,
            yMax: 1356,
            ha: 1356,
            leftSideBearing: 45,
            advanceWidth: 1479,
        },
        Z: {
            xMin: 18,
            xMax: 1222,
            yMin: 0,
            yMax: 1356,
            ha: 1356,
            leftSideBearing: 18,
            advanceWidth: 1251,
        },
        '[': {
            xMin: 180,
            xMax: 612,
            yMin: -319,
            yMax: 1355,
            ha: 1674,
            leftSideBearing: 180,
            advanceWidth: 682,
        },
        '\\': {
            xMin: -17,
            xMax: 586,
            yMin: -27,
            yMax: 1383,
            ha: 1410,
            leftSideBearing: -17,
            advanceWidth: 569,
        },
        ']': {
            xMin: 70,
            xMax: 502,
            yMin: -319,
            yMax: 1355,
            ha: 1674,
            leftSideBearing: 70,
            advanceWidth: 682,
        },
        '^': {
            xMin: 49,
            xMax: 914,
            yMin: 608,
            yMax: 1355,
            ha: 747,
            leftSideBearing: 49,
            advanceWidth: 961,
        },
        _: {
            xMin: 0,
            xMax: 1024,
            yMin: -255,
            yMax: -153,
            ha: 102,
            leftSideBearing: 0,
            advanceWidth: 1024,
        },
        '`': {
            xMin: 39,
            xMax: 499,
            yMin: 1037,
            yMax: 1392.509803639748,
            ha: 355.50980363974804,
            leftSideBearing: 39,
            advanceWidth: 682,
        },
        a: {
            xMin: 76,
            xMax: 905,
            yMin: -20,
            yMax: 942,
            ha: 962,
            leftSideBearing: 76,
            advanceWidth: 909,
        },
        b: {
            xMin: 6,
            xMax: 958,
            yMin: -20,
            yMax: 1399,
            ha: 1419,
            leftSideBearing: 6,
            advanceWidth: 1024,
        },
        c: {
            xMin: 51,
            xMax: 843,
            yMin: -20,
            yMax: 942,
            ha: 962,
            leftSideBearing: 51,
            advanceWidth: 909,
        },
        d: {
            xMin: 55,
            xMax: 1006,
            yMin: -20,
            yMax: 1399,
            ha: 1419,
            leftSideBearing: 55,
            advanceWidth: 1024,
        },
        e: {
            xMin: 51,
            xMax: 868,
            yMin: -20,
            yMax: 942,
            ha: 962,
            leftSideBearing: 51,
            advanceWidth: 909,
        },
        f: {
            xMin: 41,
            xMax: 783,
            yMin: 0,
            yMax: 1399,
            ha: 1399,
            leftSideBearing: 41,
            advanceWidth: 682,
        },
        g: {
            xMin: 57,
            xMax: 963,
            yMin: -446,
            yMax: 942,
            ha: 1388,
            leftSideBearing: 57,
            advanceWidth: 1024,
        },
        h: {
            xMin: 18,
            xMax: 997,
            yMin: 0,
            yMax: 1399,
            ha: 1399,
            leftSideBearing: 18,
            advanceWidth: 1024,
        },
        i: {
            xMin: 33,
            xMax: 516,
            yMin: 0,
            yMax: 1399,
            ha: 1399,
            leftSideBearing: 33,
            advanceWidth: 569,
        },
        j: {
            xMin: -142,
            xMax: 397,
            yMin: -446,
            yMax: 1399,
            ha: 1845,
            leftSideBearing: -142,
            advanceWidth: 569,
        },
        k: {
            xMin: 14,
            xMax: 1029,
            yMin: 0,
            yMax: 1399,
            ha: 1399,
            leftSideBearing: 14,
            advanceWidth: 1024,
        },
        l: {
            xMin: 39,
            xMax: 523,
            yMin: 0,
            yMax: 1399,
            ha: 1399,
            leftSideBearing: 39,
            advanceWidth: 569,
        },
        m: {
            xMin: 33,
            xMax: 1587,
            yMin: 0,
            yMax: 944,
            ha: 944,
            leftSideBearing: 33,
            advanceWidth: 1593,
        },
        n: {
            xMin: 33,
            xMax: 993,
            yMin: 0,
            yMax: 944,
            ha: 944,
            leftSideBearing: 33,
            advanceWidth: 1024,
        },
        o: {
            xMin: 59,
            xMax: 963,
            yMin: -20,
            yMax: 942,
            ha: 962,
            leftSideBearing: 59,
            advanceWidth: 1024,
        },
        p: {
            xMin: 10,
            xMax: 964,
            yMin: -443,
            yMax: 944,
            ha: 1387,
            leftSideBearing: 10,
            advanceWidth: 1024,
        },
        q: {
            xMin: 49,
            xMax: 999,
            yMin: -443,
            yMax: 942.0135137169275,
            ha: 1385.0135137169275,
            leftSideBearing: 49,
            advanceWidth: 1024,
        },
        r: {
            xMin: 10,
            xMax: 685,
            yMin: 0,
            yMax: 944,
            ha: 944,
            leftSideBearing: 10,
            advanceWidth: 682,
        },
        s: {
            xMin: 104,
            xMax: 713,
            yMin: -20,
            yMax: 942.0263161804552,
            ha: 962.0263161804552,
            leftSideBearing: 104,
            advanceWidth: 797,
        },
        t: {
            xMin: 27,
            xMax: 572,
            yMin: -18,
            yMax: 1186,
            ha: 1204,
            leftSideBearing: 27,
            advanceWidth: 569,
        },
        u: {
            xMin: 18,
            xMax: 981,
            yMin: -21,
            yMax: 921,
            ha: 942,
            leftSideBearing: 18,
            advanceWidth: 1024,
        },
        v: {
            xMin: 39,
            xMax: 976,
            yMin: -28,
            yMax: 921,
            ha: 949,
            leftSideBearing: 39,
            advanceWidth: 1024,
        },
        w: {
            xMin: 43,
            xMax: 1423,
            yMin: -28,
            yMax: 921,
            ha: 949,
            leftSideBearing: 43,
            advanceWidth: 1479,
        },
        x: {
            xMin: 35,
            xMax: 989,
            yMin: 0,
            yMax: 921,
            ha: 921,
            leftSideBearing: 35,
            advanceWidth: 1024,
        },
        y: {
            xMin: 29,
            xMax: 976,
            yMin: -445,
            yMax: 921,
            ha: 1366,
            leftSideBearing: 29,
            advanceWidth: 1024,
        },
        z: {
            xMin: 55,
            xMax: 855,
            yMin: 0,
            yMax: 921,
            ha: 921,
            leftSideBearing: 55,
            advanceWidth: 909,
        },
        '{': {
            xMin: 205,
            xMax: 717,
            yMin: -377,
            yMax: 1397,
            ha: 1774,
            leftSideBearing: 205,
            advanceWidth: 983,
        },
        '|': {
            xMin: 137,
            xMax: 273,
            yMin: -512,
            yMax: 1535,
            ha: 2047,
            leftSideBearing: 137,
            advanceWidth: 410,
        },
        '}': {
            xMin: 266,
            xMax: 778,
            yMin: -377,
            yMax: 1397,
            ha: 1774,
            leftSideBearing: 266,
            advanceWidth: 983,
        },
        '~': {
            xMin: 82,
            xMax: 1028,
            yMin: 380,
            yMax: 666,
            ha: 286,
            leftSideBearing: 82,
            advanceWidth: 1108,
        },
    },
    fontFamily: 'serif',
    resolution: 2048,
    generatedOn: '2020-10-18T19:03:12.514Z',
};
